const KEYCLOAK_IDP_HINT = process.env.REACT_APP_KEYCLOAK_IDP_HINT;

export const getOAuth2StartUrl = (redirectUrl?: string): string => {
    const rd = redirectUrl || window.location.href;
    const baseUrl = `${window.location.protocol}//${window.location.host}/oauth2/start?rd=${encodeURIComponent(rd)}`;
    const idpHint = KEYCLOAK_IDP_HINT ? `&kc_idp_hint=${KEYCLOAK_IDP_HINT}` : '';
    return `${baseUrl}${idpHint}`;
};
